// One request per worker; all exit paths release the worker and its buffers.
export default function runWorker<T>(
    worker: Worker, message: unknown, transfer: Transferable[] = [], signal?: AbortSignal,
): Promise<T> {
    return new Promise((resolve, reject) => {
        const cleanup = () => {
            clearTimeout(timeout);
            signal?.removeEventListener('abort', abort);
            worker.onmessage = worker.onerror = worker.onmessageerror = null;
            worker.terminate();
        };
        const fail = (error: unknown) => { cleanup(); reject(error); };
        const abort = () => fail(new DOMException('Upload cancelled', 'AbortError'));
        const timeout = setTimeout(() => fail(new Error('Image worker timed out')), 120000);
        worker.onmessage = event => { cleanup(); resolve(event.data); };
        worker.onerror = event => { event.preventDefault(); fail(new Error(event.message || 'Image worker failed')); };
        worker.onmessageerror = () => fail(new Error('Invalid image worker response'));
        signal?.addEventListener('abort', abort, { once: true });
        if (signal?.aborted) { abort(); return; }
        try { worker.postMessage(message, transfer); } catch (error) { fail(error); }
    });
}
